import { all } from "@redux-saga/core/effects";
import { normalizersSagas } from "services/Normalizers/sagas";
import { getUsersSaga } from "services/Users/sagas";
import { publishRequestStatusesSagas } from "services/PublishRequestStatuses/sagas";
import { getBranchesSagas } from "services/Branch/sagas";
import { getReceiver } from "services/Receiver/sagas";
import { getConfigCiTestCasesSagas } from "services/ConfigCiTestCases/sagas";
import { getConfigCiTestCasesStatusesSagas } from "services/ConfigCiTestCasesStatuses/sagas";
import { getBrandsSagas } from "services/Brand/sagas";
import { getPlatformsSaga } from "services/Platforms/sagas";
import { getLanguagesSaga } from "services/Language/sagas";
import { getCountriesSaga } from "services/Countries/sagas";
import {getSiteGroupsSagas} from "services/SiteGroup/sagas";

export function* servicesSagas() {
    yield all([
        getReceiver(),
        getBranchesSagas(),
        getBrandsSagas(),
        normalizersSagas(),
        getUsersSaga(),
        publishRequestStatusesSagas(),
        getConfigCiTestCasesSagas(),
        getConfigCiTestCasesStatusesSagas(),
        getPlatformsSaga(),
        getLanguagesSaga(),
        getSiteGroupsSagas(),
        getCountriesSaga()
    ]);
}
